export const whyChooseUs = [
  {
    icon: "code",
    title: "Engineer-Built Websites",
    text: "Modern, fast, mobile-friendly websites — not templates.",
  },
  {
    icon: "map",
    title: "Google Business & Maps Expertise",
    text: "Google Local Guide Level 7 — we know how to get you discovered.",
  },
  {
    icon: "billing",
    title: "Affordable Business Software",
    text: "Simple billing, inventory, records & daily-ops tools, priced for small businesses.",
  },
  {
    icon: "phone",
    title: "Direct Call & WhatsApp",
    text: "Make it easy for customers to reach you instantly.",
  },
  {
    icon: "all-in-one",
    title: "All-in-One Platform",
    text: "Website, business tools, maps & hosting — all under one roof.",
    featured: true,
  },
];
